import { IAuthStore } from "./types";
import { IRootStore } from "..";

export const getIsLoggedIn = ({
  authStore
}: IRootStore): IAuthStore["isLoggedIn"] => authStore.isLoggedIn;
